import React from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { UsersIcon, BriefcaseIcon, CheckIcon, StarIcon } from 'lucide-react';
const Teams = () => {
  // Mock teams data
  const teams = [{
    id: 1,
    name: 'WebTech Solutions',
    logo: 'https://via.placeholder.com/100?text=WTS',
    description: 'Full-stack development team specializing in Laravel and Vue.js applications.',
    members: 8,
    location: 'San Francisco, CA',
    projects: 45,
    services: ['Web Development', 'API Integration', 'E-commerce']
  }, {
    id: 2,
    name: 'DevOps Ninjas',
    logo: 'https://via.placeholder.com/100?text=DN',
    description: 'Expert team focused on DevOps, CI/CD pipelines, and cloud infrastructure for Laravel apps.',
    members: 5,
    location: 'London, UK',
    projects: 32,
    services: ['DevOps', 'AWS', 'Docker', 'CI/CD']
  }, {
    id: 3,
    name: 'UX Wizards',
    logo: 'https://via.placeholder.com/100?text=UXW',
    description: 'Design and development team creating beautiful, user-friendly Laravel applications.',
    members: 12,
    location: 'Berlin, Germany',
    projects: 78,
    services: ['UI/UX Design', 'Frontend Development', 'User Testing']
  }, {
    id: 4,
    name: 'Data Masters',
    logo: 'https://via.placeholder.com/100?text=DM',
    description: 'Specialized in data-heavy Laravel applications, analytics, and reporting solutions.',
    members: 7,
    location: 'Toronto, Canada',
    projects: 29,
    services: ['Data Analytics', 'Reporting Systems', 'Database Optimization']
  }];
  return <div className="w-full" data-id="element-1300">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-blue-50 to-white py-16" data-id="element-1301">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1302">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1303">
            <h1 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1304">
              Find Expert Laravel Development Teams
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-1305">
              Connect with agencies and development teams specialized in Laravel
              projects
            </p>
            <Button variant="primary" size="lg" data-id="element-1306">
              Browse Teams
            </Button>
          </div>
        </div>
      </section>
      {/* Teams List */}
      <section className="py-16" data-id="element-1307">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1308">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1309">
            {teams.map(team => <Card key={team.id} hover className="flex flex-col h-full shadow-sm rounded-xl" data-id="element-1310">
                <div className="flex items-start" data-id="element-1311">
                  <img src={team.logo} alt={team.name} className="w-16 h-16 rounded-md object-cover" data-id="element-1312" />
                  <div className="ml-4" data-id="element-1313">
                    <h3 className="text-xl font-semibold text-gray-900" data-id="element-1314">
                      {team.name}
                    </h3>
                    <div className="flex items-center text-sm text-gray-500 mt-1" data-id="element-1315">
                      <UsersIcon className="h-4 w-4 mr-1" data-id="element-1316" />
                      {team.members} team members
                      <span className="mx-2" data-id="element-1317">•</span>
                      {team.location}
                    </div>
                  </div>
                </div>
                <p className="mt-4 text-gray-600" data-id="element-1318">{team.description}</p>
                <div className="mt-4" data-id="element-1319">
                  <div className="text-sm font-medium text-gray-700" data-id="element-1320">
                    Services:
                  </div>
                  <div className="flex flex-wrap gap-2 mt-2" data-id="element-1321">
                    {team.services.map((service, index) => <span key={index} className="bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded" data-id="element-1322">
                        {service}
                      </span>)}
                  </div>
                </div>
                <div className="mt-4 pt-4 border-t border-gray-200 flex items-center justify-between" data-id="element-1323">
                  <div className="flex items-center text-sm text-gray-500" data-id="element-1324">
                    <BriefcaseIcon className="h-4 w-4 mr-1" data-id="element-1325" />
                    {team.projects} projects completed
                  </div>
                  <Button variant="outline" size="sm" data-id="element-1326">
                    View Profile
                  </Button>
                </div>
              </Card>)}
          </div>
        </div>
      </section>
      {/* Why Choose a Team Section */}
      <section className="py-16 bg-gray-50" data-id="element-1327">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1328">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1329">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1330">
              Why Choose a Development Team?
            </h2>
            <p className="text-lg text-gray-600" data-id="element-1331">
              Development teams offer comprehensive solutions for complex
              projects
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-1332">
            <Card hover className="shadow-sm rounded-xl" data-id="element-1333">
              <div className="flex items-center mb-4" data-id="element-1334">
                <div className="bg-blue-100 p-3 rounded-full" data-id="element-1335">
                  <UsersIcon className="h-6 w-6 text-blue-600" data-id="element-1336" />
                </div>
                <h3 className="text-xl font-semibold ml-4" data-id="element-1337">
                  Diverse Expertise
                </h3>
              </div>
              <p className="text-gray-600" data-id="element-1338">
                Access a range of specialists including designers, developers,
                and QA engineers all working together.
              </p>
            </Card>
            <Card hover className="shadow-sm rounded-xl" data-id="element-1339">
              <div className="flex items-center mb-4" data-id="element-1340">
                <div className="bg-blue-100 p-3 rounded-full" data-id="element-1341">
                  <CheckIcon className="h-6 w-6 text-blue-600" data-id="element-1342" />
                </div>
                <h3 className="text-xl font-semibold ml-4" data-id="element-1343">Proven Processes</h3>
              </div>
              <p className="text-gray-600" data-id="element-1344">
                Benefit from established workflows, code reviews, and quality
                assurance procedures.
              </p>
            </Card>
            <Card hover className="shadow-sm rounded-xl" data-id="element-1345">
              <div className="flex items-center mb-4" data-id="element-1346">
                <div className="bg-blue-100 p-3 rounded-full" data-id="element-1347">
                  <StarIcon className="h-6 w-6 text-blue-600" data-id="element-1348" />
                </div>
                <h3 className="text-xl font-semibold ml-4" data-id="element-1349">
                  End-to-End Service
                </h3>
              </div>
              <p className="text-gray-600" data-id="element-1350">
                Get comprehensive project management from planning and design
                through development and launch.
              </p>
            </Card>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16" data-id="element-1351">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1352">
          <div className="bg-blue-600 rounded-xl shadow-lg overflow-hidden" data-id="element-1353">
            <div className="px-6 py-12 md:p-12 text-center md:text-left md:flex md:items-center md:justify-between" data-id="element-1354">
              <div data-id="element-1355">
                <h2 className="text-2xl font-bold text-white mb-2" data-id="element-1356">
                  Need a team for your project?
                </h2>
                <p className="text-blue-100" data-id="element-1357">
                  Post your project requirements and get matched with the right
                  team.
                </p>
              </div>
              <div className="mt-8 md:mt-0 md:ml-8" data-id="element-1358">
                <Button variant="secondary" size="lg" className="text-blue-600" data-id="element-1359">
                  Post a Project
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Teams;